import SimpleLightbox from 'simplelightbox';
import 'simplelightbox/dist/simple-lightbox.min.css';

const galleryEl = document.querySelector('#gallery');
const loaderEl = document.querySelector('#loader');

export const lightbox = new SimpleLightbox('.gallery a', {
  captionsData: 'alt',
  captionDelay: 250,
});

export function createGallery(images) {
  const markup = images
    .map(
      ({ webformatURL, largeImageURL, tags, likes, views, comments, downloads }) => `
    <li class="gallery__item">
      <a class="gallery__link" href="${largeImageURL}">
        <img
          class="gallery__img"
          src="${webformatURL}"
          alt="${tags}"
          loading="lazy"
        />
        <div class="gallery__overlay">
          <ul class="gallery__stats">
            <li class="gallery__stat">
              <span class="gallery__stat-value">${likes}</span>
              <span class="gallery__stat-label">Likes</span>
            </li>
            <li class="gallery__stat">
              <span class="gallery__stat-value">${views}</span>
              <span class="gallery__stat-label">Views</span>
            </li>
            <li class="gallery__stat">
              <span class="gallery__stat-value">${comments}</span>
              <span class="gallery__stat-label">Comments</span>
            </li>
            <li class="gallery__stat">
              <span class="gallery__stat-value">${downloads}</span>
              <span class="gallery__stat-label">Downloads</span>
            </li>
          </ul>
        </div>
      </a>
    </li>`
    )
    .join('');

  galleryEl.insertAdjacentHTML('beforeend', markup);
  lightbox.refresh();
}

export function clearGallery() {
  galleryEl.innerHTML = '';
}

export function showLoader() {
  loaderEl.classList.add('is-visible');
}

export function hideLoader() {
  loaderEl.classList.remove('is-visible');
}